export const CDRAPI = {
  /**
   * CDR报价模块
   */
  uploadCdrFile: '/server-cdr/analysis/uploadCdrFileOnly', // 上传并初始化CDR文件
  resetCdrFile: '/analysis/resetCdrFile',
  groupShapes: '/analysis/groupShapes',
  combineShapes: '/analysis/combineShapes',
  smartCombine: '/analysis/smartCombine',
  breakApart: '/analysis/breakApartShapes',
  convertToCurves: '/analysis/convertToCurves',
  reloadCdrFile: '/analysis/reloadCdrFile',
  DoAnalysis: '/analysis/DoAnalysis',
  loadCdrFileDemo: '/server-cdr/analysis/loadCdrFileDemo',
  imageResource: '/server-cdr/resources'
}



// WEBPACK FOOTER //
// ./src/util/cdrapi.js